import ApiClient from "Store/client";

export const assignWorksheetToStudentApi = (body) =>
  ApiClient(`api/commands/assign-worksheet-to-student`, {
    method: "POST",
    body
  });

export const resetStudentWorksheetsApi = (body) =>
  ApiClient(`api/commands/reset-student-worksheets`, {
    method: "PATCH",
    body
  });

export const updateStudentWorksheetProblemFlagApi = (body) =>
  ApiClient(`api/commands/flag-student-worksheet-problem`, {
    method: "POST",
    body,
    type: "text"
  });

export const excuseStudentWorksheetLatenessApi = (body) =>
  ApiClient(`api/commands/excuse-student-worksheet-lateness`, {
    method: "PATCH",
    body
  });

export const updateStudentWorksheetStatusApi = (body) =>
  ApiClient(`api/commands/update-student-worksheet-status`, {
    method: "PATCH",
    body
  });

export const addBulkAnswersToWorksheetApi = (body) =>
  ApiClient(`api/commands/bulk-student-worksheet-answers`, { method: "PATCH", body });

export const markAllWorksheetFlagsReviewedApi = (body) =>
  ApiClient(`api/commands/mark-student-worksheet-flags-reviewed`, {
    method: "POST",
    body
  });

export const fetchStudentWorksheetApi = (student_id, worksheet_id) =>
  ApiClient<Worksheet>(`api/students/${student_id}/student_worksheets/${worksheet_id}`);

export const rescheduleStudentWorksheetsApi = (body) =>
  ApiClient(`api/commands/reschedule-student-worksheets`, {
    method: "PATCH",
    body
  });

export const unassignStudentWorksheetsApi = (body) =>
  ApiClient(`api/commands/unassign-worksheet-to-student`, {
    method: "POST",
    body
  });

export const fetchStudentWorksheetsApi = (student, queryString = "") =>
  ApiClient<Worksheet[]>(`api/students/${student}/student_worksheets${queryString}`);

export const fetchStudentWorksheetByCategoryApi = (studentId, parameters) =>
  ApiClient<WorksheetTemplate[]>(`api/students/${studentId}/categories/worksheets${parameters}`);
